import { BASE_STOREFRONT_ENDPOINT } from '../storeEndpoint'

export const ORDERS_ENDPOINT = `${BASE_STOREFRONT_ENDPOINT}/orders`
